import { defineStore } from 'pinia'
import axios from 'axios'
import _ from 'lodash'

export const useEventStore = defineStore('event', {
	state: () => {
		return {
			events: [],
		}
	},
	getters: {
		eventsWithGallery: (state) => {
			return state.events.filter((event) => event.gallery?.length > 0)
		},
		upcoming: (state) => {
			return state.events.filter((event) => event.start_at && event.completed == false)
		},
		types: (state) => {
			let allTypes = state.events?.flatMap(({ type }) => type).filter(Boolean)
			let types = [...new Set(allTypes)].map((type) => ({ name: _.startCase(type), slug: type }))
			return _.orderBy(types, 'name')
		},
		games: (state) => {
			let allGames = state.events?.flatMap(({ games }) => games).filter(Boolean)
			let games = [...new Set(allGames.map((o) => JSON.stringify(o)))].map((string) => JSON.parse(string))
			return _.orderBy(games, 'name')
		},
		countries: (state) => {
			let allCountries = state.events?.flatMap(({ country }) => country).filter(Boolean)
			let countries = [...new Set(allCountries.map((o) => JSON.stringify(o)))].map((string) => JSON.parse(string))
			return _.orderBy(countries, 'name')
		},
		galleryGames: (state) => {
			let allGames = state.eventsWithGallery.flatMap((event) => event.games).filter(Boolean)
			let games = [...new Set(allGames.map((o) => JSON.stringify(o)))].map((string) => JSON.parse(string))
			return _.orderBy(games, 'name')
		},
		qualifiers: (state) => {
			let allQualifiers = state.events.flatMap(({ qualifier_for }) => qualifier_for ?? []).filter(Boolean)
			let qualifiers = [...new Set(allQualifiers.map((o) => JSON.stringify(o)))].map((string) => JSON.parse(string))
			return _.orderBy(qualifiers, 'name')
		},
	},
	actions: {
		setup() {
			this.getEvents()
		},
		getEvents() {
			return axios
				.get('/api/tournament')
				.then((events) => {
					this.events = events.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
})
